export default {
  fields: {
    sales: {
      label: 'Sales',
    },
    gift_cards_sales: {
      label: 'Gift Card Sales',
    },
    average_order_value: {
      label: 'Average Order Value',
    },
    savings: {
      label: 'Savings on third party fees',
    },
    reservations: {
      label: 'Reservations',
    },
    sales_from_email: {
      label: 'Sales from Email',
    },
    sales_from_google_seo: {
      label: 'Sales from Google SEO',
    },
    sales_from_google_business_profile: {
      label: 'Sales from Google Business',
    },
    sales_from_google_ads: {
      label: 'Sales from Google Ads',
    },
    sales_from_flyers: {
      label: 'Sales from Flyers',
    },
    sales_from_social_media: {
      label: 'Sales from Social Media',
    },
    sales_from_facebook_ads: {
      label: 'Sales from Facebook Ads',
    },
    tips: {
      label: 'Tips',
    },
    new_customers: {
      label: 'New Customers',
    },
    returning_customers: {
      label: 'Returning Customers',
    },
    new_visitors: {
      label: 'New Visitors',
    },
    new_followers: {
      label: 'New Followers',
    },
    total_followers: {
      label: 'Total Followers',
    },
    delivered_messages: {
      label: 'Delivered Messages',
    },
    average_open_rate: {
      label: 'Average Email Open Rate',
    },
    average_click_rate: {
      label: 'Average Click Rate',
    },
    website_visitors_from_email: {
      label: 'Website Visitors from Email',
    },
    sales_from_google_business: {
      label: 'Sales from Google Business',
    },
    total_reservations: {
      label: 'Reservations',
    },
    website_visitors_from_google_seo: {
      label: 'Website Clicks from Google SEO',
    },
    website_clicks_from_google_business: {
      label: 'Website Clicks from Google Business',
    },
    website_visitors_from_google_ads: {
      label: 'Website Clicks from Google Ads',
    },
    website_visitors_from_social_media: {
      label: 'Website Clicks from Social Media',
    },
    calls_from_google_ads: {
      label: 'Calls from Google Ads',
    },
    directions_from_google_ads: {
      label: 'Directions from Google Ads',
    },
    google_seo_orders_count: {
      label: 'Google SEO',
    },
    google_business_orders_count: {
      label: 'Google Business',
    },
    google_ads_orders_count: {
      label: 'Google Ads',
    },
    facebook_ads_orders_count: {
      label: 'Facebook Ads',
    },
    social_media_orders_count: {
      label: 'Social Media',
    },
    flyer_orders_count: {
      label: 'Flyers',
    },
    email_orders_count: {
      label: 'Emails',
    },
    other_orders_count: {
      label: 'Others',
    },
    gmv: {
      label: 'GMV',
    },
    gift_cards_gmv: {
      label: 'Gift Cards',
    },
    net_billed_revenue: {
      label: 'Billed Revenue (NET)',
    },
    net_billed_revenue_subscription: {
      label: 'Billed subscription revenue',
    },
    net_billed_revenue_service_fee: {
      label: 'Billed service fee revenue',
    },
    net_billed_revenue_external_delivery_platform_fee: {
      label: 'Billed delivery fee revenue',
    },
    net_billed_revenue_other: {
      label: 'Billed service charges revenue',
    },
    net_billed_revenue_external_delivery_passthrough_fee: {
      label: 'Billed Delivery - Pass-through',
    },
    net_billed_revenue_platform_processing_fee: {
      label: 'Billed platform processing fee revenue',
    },
    gross_cash_income: {
      label: 'Cash income (Gross)',
    },
    gross_cash_income_subscription: {
      label: 'Cash income from subscriptions',
    },
    gross_cash_income_service_fee: {
      label: 'Cash income from service fees',
    },
    gross_cash_income_external_delivery_platform_fee: {
      label: 'Cash income from delivery fees',
    },
    gross_cash_income_other: {
      label: 'Cash income from service charges',
    },
    gross_cash_income_external_delivery_passthrough_fee: {
      label: 'Cash income from delivery pass-through fees',
    },
    gross_cash_income_platform_processing_fee: {
      label: 'Cash income from platform processing fees',
    },
    net_cash_income: {
      label: 'Cash income (NET)',
    },
    net_cash_income_subscription: {
      label: 'Cash income from subscriptions',
    },
    net_cash_income_service_fee: {
      label: 'Cash income from service fees',
    },
    net_cash_income_external_delivery_platform_fee: {
      label: 'Cash income from delivery fees',
    },
    net_cash_income_other: {
      label: 'Cash income from service charges',
    },
    net_cash_income_external_delivery_passthrough_fee: {
      label: 'Cash income from delivery pass-through fees',
    },
    net_cash_income_platform_processing_fee: {
      label: 'Cash income from platform processing fees',
    },
    manual_connect_transfers: {
      label: 'Refunded to restaurants',
    },
    processing_fees: {
      label: 'Processing Fees',
    },
    processing_fees_stripe: {
      label: 'Processing Fees (Stripe)',
    },
    processing_fees_paypal: {
      label: 'Processing Fees (PayPal)',
    },
    rejected_orders: {
      label: 'Rejected Orders',
    },
    rejected_orders_amount: {
      label: 'Rejected Orders Amount',
    },
    rejected_orders_count: {
      label: 'Rejected Orders Count',
    },
    rejected_orders_rate: {
      label: 'Rejected Orders Rate',
    },
    rejected_orders_rate_breakdown: {
      label: 'Rejected Orders Rate Breakdown',
    },
    orders: {
      label: 'Orders',
    },
    total_orders: {
      label: 'Total Orders',
    },
    pickup_orders_rate: {
      label: 'Pickup Orders Rate',
    },
    delivery_orders_rate: {
      label: 'Delivery Orders Rate',
    },
    other_orders_rate: {
      label: 'Other Orders Rate',
    },
    customers: {
      label: 'Total Customers',
    },
    customers_auth_state: {
      label: 'Customer Authentication State',
    },
    website_reservations: {
      label: 'Website Reservations',
    },
    google_reservations: {
      label: 'Google Reservations',
    },
    companies: {
      label: 'Companies',
    },
    live_companies: {
      label: 'Live Restaurants',
    },
    live_companies_percentage: {
      label: 'Live Restaurants Percentage',
    },
    setup_packages_breakdown: {
      label: 'Setup packages',
    },
    setup_packages_billing_mode_breakdown: {
      label: 'Setup packages by billing source',
    },
    crossed_sales_level_this_month: {
      label: 'Crossed Sales Level This Month',
    },
    crossed_sales_level_total: {
      label: 'Crossed Sales Level Total',
    },
    crossed_sales_level_percentage: {
      label: 'Crossed Sales Level Percentage',
    },
    has_delivery: {
      label: 'Own Delivery',
    },
    has_only_pickup: {
      label: 'Only Pickup',
    },
    has_storefront: {
      label: 'Has Storefront',
    },
    has_storefront_percentage: {
      label: 'Storefront Percentage',
    },
    use_external_delivery: {
      label: 'External Delivery',
    },
    crossed_sales: {
      label: 'Crossed {{value}} sales',
    },
    restaurant_partners: {
      label: 'Restaurant Partners',
    },
    registered_restaurants: {
      label: 'Registered Restaurants',
    },
    signed_restaurants: {
      label: 'Signed Restaurants',
    },
    use_reservations: {
      label: 'Use Reservations',
    },
    number: {
      label: 'Number',
    },
    restaurants_percentage: {
      label: 'Restaurants Percentage',
    },
    crossed_sales_level: {
      label: 'Crossed Sales Level',
    },
    order_method: {
      label: 'Order Method',
    },
    own_delivery: {
      label: 'Own Delivery',
    },
    only_pickup: {
      label: 'Only Pickup',
    },
    storefront: {
      label: 'Storefront',
    },
    sales_tiers: {
      label: 'Sales Tiers',
    },
    new_pricing_adoption_rate: {
      label: 'New pricing adoption rate',
    },
    mobile_app_attach_rate: {
      label: 'Mobile app attach rate',
    },
    mobile_app_setup_fee_breakdown: {
      label: 'Mobile app setup fees chosen',
    },
    first_delivery: {
      label: 'Uber (First Delivery)',
    },
    wolt_drive: {
      label: 'Wolt',
    },
    uber_drive: {
      label: 'Uber',
    },
    delivery_quotes_count: {
      label: 'Delivery Quotes Count',
    },
    deliveries_count: {
      label: 'Deliveries Count',
    },
    delivery_conversion: {
      label: 'Delivery Conversion Rate',
    },
    delivery_quotes_provider_breakdown: {
      label: 'Delivery Quotes Provider Breakdown',
    },
    deliveries_provider_breakdown: {
      label: 'Deliveries Provider Breakdown',
    },
    delivery_distance_breakdown: {
      label: 'Delivery Distance Breakdown',
    },
    total_delivered: {
      label: 'Delivered Messages',
    },
    website_visitors_from_google_business_profile: {
      label: 'Website clicks from Google Business',
    },
    google_business_impressions: {
      label: 'Impressions from Google Business',
    },
    google_business_website_clicks: {
      label: 'Website clicks from Google Business',
    },
    google_ads_impressions: {
      label: 'Impressions Google Ads',
    },
    google_ads_clicks: {
      label: 'Clicks Google Ads',
    },
    google_ads_phone_calls: {
      label: 'Calls Google Ads',
    },
    google_ads_directions: {
      label: 'Directions Google Ads',
    },
    google_ads_absolute_top_impression_percentage: {
      label: 'Average Absolute Top-Impression Percentage Google Ads',
    },
    google_ads_average_cpc: {
      label: 'Average Cost Per Click Google Ads',
    },
    google_ads_conversions_from_interactions_rate: {
      label: 'Average Conversions from Interactions Rate Google Ads',
    },
    website_visits: {
      label: 'Website Visits',
    },
    website_visitors: {
      label: 'Website Visitors',
    },
    companies_with_activated_reservations: {
      label: 'Restaurants with activated reservations',
    },
    online_orders_count: {
      label: 'Online Orders',
    },
    cash_orders_count: {
      label: 'Online Orders',
    },
    cash_sales: {
      label: 'Cash Sales',
    },
    online_sales: {
      label: 'Online Sales',
    },
    payouts: {
      label: 'Payouts',
    },
    last_payout_amount: {
      label: 'Last payout',
    },
    pending_payout_amount: {
      label: 'In transit',
    },
    future_payout_amount: {
      label: 'Available for future payouts',
    },
    mobile_app_average_order_value: {
      label: 'AOV via App',
    },
    mobile_app_gmv: {
      label: 'Total Sales via App',
    },
    mobile_app_gmv_percentage: {
      label: 'Revenue % from App',
    },
    mobile_app_downloads: {
      label: 'Total App Downloads',
    },
    mobile_app_orders_count: {
      label: 'Total Orders via App',
    },
    net_billed_revenue_gift_cards: {
      label: 'Billed gift cards revenue',
    },
    gross_cash_income_gift_cards: {
      label: 'Cash income from gift cards',
    },
    net_cash_income_gift_cards: {
      label: 'Cash income from gift cards',
    },
    platform_processing_fees: {
      label: 'Platform Processing Fees',
    },
  },
};
